var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGolfGoal22Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.9167V1.83337L18.3333 5.50004L11 9.16671",
    stroke: "#C3F0F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8375 9.37749C19.3253 10.8809 19.371 12.4929 18.969 14.0215C18.5671 15.5502 17.7344 16.9312 16.5702 18.0003C15.406 19.0693 13.9591 19.7815 12.4018 20.0519C10.8445 20.3224 9.2423 20.1397 7.78579 19.5258C6.32927 18.9119 5.07979 17.8924 4.18597 16.5888C3.29216 15.2852 2.79165 13.7522 2.74399 12.1723C2.69633 10.5924 3.10352 9.0321 3.91713 7.67697C4.73074 6.32183 5.9165 5.22894 7.33336 4.52832",
    stroke: "#C3F0F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3334 9.16675C6.87407 9.77819 6.57503 10.4948 6.46353 11.2514C6.35203 12.008 6.43162 12.7805 6.69504 13.4984C6.95846 14.2164 7.39734 14.857 7.9717 15.3619C8.54606 15.8669 9.23764 16.22 9.98342 16.3893C10.7292 16.5586 11.5055 16.5385 12.2416 16.331C12.9776 16.1235 13.6501 15.7351 14.1976 15.2012C14.7451 14.6673 15.1504 14.0049 15.3764 13.2744C15.6025 12.5438 15.6421 11.7682 15.4917 11.0184",
    stroke: "#C3F0F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfGoal22Px);
export default __webpack_public_path__ + "static/media/golf_goal_22px.34ab850ba39f540815c7e18bf89088f7.svg";
export { ForwardRef as ReactComponent };